import { type FC } from "react";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { StatusLabels } from "./src/status_labels";
import { FeatureLabels } from "./src/feature_labels";
import { ButtonContents } from "./src/button_contents";
import { Header } from "./src/Header";
import { RelatedHeader } from "./src/RelatedHeader";
import { SalaryAndShopRequirements } from "./src/salary_and_shop_requirements";
import { DetailedInformation } from "./src/detailed_information";
import { SalaryAndWorktimeRequirements } from "./src/salary_and_worktime_requirements";
import { type CassetteProps } from "./src/cassette_props";
import * as styles from "./styles.css";

export const Cassette: FC<CassetteProps> = ({
  cassetteHash: {
    workCode,
    detailUrl,
    entryUrl,
    query,
    shopOrBrandName,
    businessTypeAndOccupation,
    businessType,
    occupation,
    title,
    imgSrc,
    statusLabelFlags,
    awards2026Labels,
    awards2025Labels,
    awards2024Labels,
    awards2023Labels,
    awards2022Labels,
    awardsLabels,
    featureLabels,
    dream,
    commitment,
    requirements,
    buttonContents,
    telNumberContent,
    isShowPinpontHighRankLabel,
    isReviewLabel,
    searchEvents: {
      cassetteEvent: {
        cassetteGaAction,
        cassetteGaLabel,
        cassetteAppierAction,
        cassetteSearchListRank,
      },
      clientShopsEvent,
      keepButtonEvent,
      scoutButtonEvent,
      entryButtonEvent,
    },
  },
  dummyImgPath,
  isSp,
  login,
  keepedFlag,
  cassetteType,
  className,
  showAwardsLabelFlag,
  isContractRunning,
}) => (
  <div className={className}>
    <section
      className={`js-link-expand ${cassetteType === "search" ? styles.cassetteOuterSearch : styles.cassetteOuterDefault}`}
      data-job-code={workCode}
      id={`code-${workCode}`}
    >
      {Object.values(statusLabelFlags).includes(true) && (
        <StatusLabels
          premiumScoutFlag={statusLabelFlags.premiumScoutFlag}
          newContentFlag={statusLabelFlags.newContentFlag}
          publishingEndUpCloseFlag={statusLabelFlags.publishingEndUpCloseFlag}
          scoutFlag={statusLabelFlags.scoutFlag}
        />
      )}
      {isContractRunning && (
        <div className={styles.imageOuterSp}>
          <LazyLoadImage src={imgSrc} dummyImgPath={dummyImgPath} alt="" width={657} height={370} />
        </div>
      )}
      <div className={styles.headerOuter}>
        {isShowPinpontHighRankLabel && (
          <span className={styles.pinpointLabel}>これはピンポイント上位表示です</span>
        )}
        <a
          className={`js-link-expand__target ga-click appier-click js-add-query-strings ga-impression ${styles.headerLink}`}
          href={detailUrl}
          data-ga-action={cassetteGaAction}
          data-ga-label={cassetteGaLabel}
          data-query-str={query}
          data-appier-action={cassetteAppierAction}
          data-search-list-rank={cassetteSearchListRank}
        >
          {(() => {
            if (
              cassetteType === "search" ||
              cassetteType === "search_results_with_dream_and_commitment"
            ) {
              return (
                <Header
                  businessTypeAndOccupation={businessTypeAndOccupation}
                  shopOrBrandName={shopOrBrandName}
                />
              );
            }
            return <RelatedHeader businessType={businessType} occupation={occupation} />;
          })()}
          <div className={styles.headerText}>
            <p>{title}</p>
            <i className="icon-right-open-big" />
          </div>
        </a>
        <FeatureLabels
          awards2026Labels={awards2026Labels}
          awards2025Labels={awards2025Labels}
          awards2024Labels={awards2024Labels}
          awards2023Labels={awards2023Labels}
          awards2022Labels={awards2022Labels}
          awardsLabels={awardsLabels}
          featureLabels={featureLabels}
          showAwardsLabelFlag={showAwardsLabelFlag}
          isContractRunning={isContractRunning}
          isReviewLabel={isReviewLabel}
        />
      </div>
      <div className={styles.mainContentsOuter}>
        <div className={styles.mainContentsInner}>
          {(() => {
            if (cassetteType === "shop") {
              return <SalaryAndWorktimeRequirements requirements={requirements} />;
            }
            if (cassetteType === "search_results_with_dream_and_commitment") {
              return (
                <DetailedInformation
                  dream={dream}
                  commitment={commitment}
                  requirements={requirements}
                  clientShopsEvent={clientShopsEvent}
                  isSp={isSp}
                  query={query}
                />
              );
            }
            return (
              <SalaryAndShopRequirements
                requirements={requirements}
                clientShopsEvent={clientShopsEvent}
                isSp={isSp}
                query={query}
              />
            );
          })()}
          {isContractRunning && (
            <div className={styles.imageOuterPc}>
              <LazyLoadImage
                src={imgSrc}
                dummyImgPath={dummyImgPath}
                alt=""
                width={657}
                height={370}
              />
            </div>
          )}
        </div>
      </div>
      <ButtonContents
        buttonContents={buttonContents}
        telNumberContent={telNumberContent}
        keepButtonEvent={keepButtonEvent}
        scoutButtonEvent={scoutButtonEvent}
        entryButtonEvent={entryButtonEvent}
        workCode={workCode}
        query={query}
        entryUrl={entryUrl}
        login={login}
        keepedFlag={keepedFlag}
        detailUrl={detailUrl}
        isSp={isSp}
      />
    </section>
  </div>
);
